import { PlanTypeId } from '@constants/plan';
import { ELIGIBILITY_JOURNEY } from '@constants/provider';

import { EligibilityJourneyConfig } from './eligibility-config';

export class PromoJourneyConfig extends EligibilityJourneyConfig {
    protected readonly name = ELIGIBILITY_JOURNEY.PROMO;
    protected readonly offerCategoryCodeToShow: PlanTypeId = PlanTypeId.BELOW_THE_LINE_WEB;
    protected readonly wordings = {
        mainTitle: 'Opération déstockage WiFi 5\u00A0!\nOn teste votre éligibilité\u00A0?',
        noFiber: "En attendant l'arrivée de la fibre...",
    };
    protected readonly tracking = {
        page: 'Eligibilite_test_btl',
        pageCategory: 'Eligibilite',
        eCommerceStep: '',
        universe: 'Boutique_Fai',
        marketLine: 'Fai',
        variant: {
            type_offres: 'Offres_btl',
        },
        variables: {
            type_offres: 'Offres_btl',
        },
    };
}
